const text = (id, section, title, multiline = false) => ({id, section, title, type: multiline ? "MULTILINE" : "TEXT", isRequired: false})
const rating = (id, section, title, min, max, lowLabel, highLabel) => ({id, section, title, type: "SCALE", min, max, lowLabel, highLabel, isRequired: false})

export function createPresentTriggerWorksheetConfig() {
	return {
		title: "Present Trigger Worksheet",
		instructions: "With your practitioner, describe one current triggering situation. You can leave an answer open when it needs clarification.",
		allowEmptyFields: true,
		validateFormAnswers: true,
		ratingScaleMax: 10,
		focusFieldId: "selectedTarget",
		headlineFieldId: "selectedTarget",
		sections: [
			{id: "triggers", title: "Present situations, events, or stimuli"},
			{id: "target", title: "Selected present trigger"},
			{id: "responses", title: "Associated responses"},
		],
		fields: [
			text("triggerList", "triggers", "What situations, events, or stimuli trigger your reaction? List any that come to mind. We will focus on one at a time.", true),
			text("selectedTarget", "target", "Which situation, event, or stimulus that triggers you would you like to use as a target today?", true),
			{...text("picture", "responses", "What picture represents the situation, event, or stimulus that triggers you?\nIf several pictures come to mind, which picture represents the most traumatic part?\nIf no picture is available, bring the selected situation to mind instead.", true), alternativeResponse: "No picture available; attending to the selected situation instead."},
			text("negativeCognition", "responses", "What words best go with the picture that express your negative belief about yourself now?", true),
			text("positiveCognition", "responses", "When you bring up that picture or situation, what would you like to believe about yourself now?", true),
			rating("voc", "responses", "When you think of the situation or picture, how true do those positive words feel to you now?\nIf what you know in your head feels different in your gut, how true do the words feel at a gut level?", 1, 7, "Completely false", "Completely true"),
			text("emotions", "responses", "When you bring up the picture or situation and the negative words, what emotion do you feel now?", true),
			rating("sud", "responses", "How disturbing does it feel now?", 0, 10, "No disturbance or neutral", "Highest disturbance imaginable"),
			text("bodySensation", "responses", "Where do you feel the disturbance in your body?", true),
		],
		reviewLabels: {
			heading: "Practitioner review",
			status: "Target status",
			usability: "Target usability and clarification",
			preparation: "Preparation notes",
			candidate: "Candidate",
			active: "Active",
			needsClarification: "Needs clarification",
			clarificationText: "The selected trigger needs more detail.",
			unreviewed: "Not reviewed",
		},
	}
}
